export default "__VITE_ASSET__da2fcb49__"